import { useCallback, useEffect, useState } from 'react';

import { campaignAuthTaskLinkGetByShortUrl } from '@graphql/queries/task';

import client from '@api';
import { ErrorCategory, handleError } from '@services/errorService';

interface LinkData {
  campaignAuthTaskLinkGetByShortUrl?: {
    longUrl: string;
    campaignId: string;
    authId: string;
  };
}

const RedirectLink: React.FC = () => {
  const [_loading, setLoading] = useState(true);

  const getLink = useCallback(async (shortUrl: string | null) => {
    if (!shortUrl) {
      setLoading(false);
      return;
    }

    try {
      const { data } = await client().query<LinkData>({
        query: campaignAuthTaskLinkGetByShortUrl,
        variables: {
          shortUrl,
        },
        fetchPolicy: 'no-cache',
      });

      if (data.campaignAuthTaskLinkGetByShortUrl) {
        if (typeof window === 'object') {
          window.location.href = `${data?.campaignAuthTaskLinkGetByShortUrl?.longUrl}?utm_source=mrbl.bio&utm_medium=referral&utm_campaign=${data?.campaignAuthTaskLinkGetByShortUrl?.campaignId}&utm_content=${data?.campaignAuthTaskLinkGetByShortUrl?.authId}`;
        }
      }

      setLoading(false);
    } catch (error) {
      handleError(error as Error, {
        category: ErrorCategory.GRAPHQL,
        silent: true,
      });
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const shortLink =
      typeof window === 'object'
        ? window.location.pathname.split('/l/')[1]
        : null;
    getLink(shortLink);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default RedirectLink;
